import { useAuth } from "@/contexts/AuthContext";
import { LoginForm } from "@/components/auth/LoginForm";
import { Header } from "../Header";
import { MainContent } from "../MainContent";
import { VersionCheckNotify } from "@/contexts/VersionCheckContext/VersionCheckNotify";

export const AppLayout: React.FC = () => {
	const { session } = useAuth();

	return (
		<div className='min-h-screen'>
			<VersionCheckNotify />
			{session ?
				<div className="mx-auto bg-(--color-background) text-(--color-text)">
					<Header />
					<MainContent />
				</div>
				:
				<div>
					<LoginForm />
				</div>
			}
		</div>
	);
};